import { useQuery } from '@tanstack/react-query';

import { ALLOWED_VALIDATION } from 'src/features/userManagement/types';
import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/memberships/:membershipId/validator-settings/';

interface DTO {
    parkingId: string;
    membershipId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({
    parkingId,
    membershipId,
    ...params
}: DTO): Promise<{
    allowed_validation: ALLOWED_VALIDATION | undefined;
    allowed_pricing_plan: string | undefined;
}> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, membershipId }), { params });
};

interface UseQueryOptions extends DTO {
    options?: QueryConfig<QueryFnType>;
}

const useQueryHook = ({ options, ...payload }: UseQueryOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => {
            return await queryFn(payload);
        },
        enabled: !!payload.membershipId,
        ...options,
    });

export { useQueryHook as useRetrieveMembershipValidator, RESOURCE as MEMBERSHIP_VALIDATOR_RESOURCE };
